import React, { createContext, useContext, useState, useCallback } from 'react';
import { FR } from './fr';
import { setFormatLang } from './format';

// Lightweight i18n: the UI is authored in Dutch; t('<dutch>') returns the French
// translation when the language is FR (falling back to the Dutch text if a string
// isn't translated yet). The choice is persisted in localStorage. Date/month
// formatters follow the same language via setFormatLang().
const LangContext = createContext({ lang: 'nl', setLang: () => {}, t: (s) => s });

const initialLang = () => {
  let l = 'nl';
  try { l = localStorage.getItem('calum_lang') || 'nl'; } catch { /* private mode */ }
  setFormatLang(l);
  return l;
};

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(initialLang);
  const setLang = useCallback((l) => {
    try { localStorage.setItem('calum_lang', l); } catch { /* ignore */ }
    setFormatLang(l);
    setLangState(l);
  }, []);
  const t = useCallback((s) => (lang === 'fr' ? (FR[s] ?? s) : s), [lang]);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
export const useT = () => useContext(LangContext).t;

/** Compact NL/FR switch (topbar, login). */
export function LangToggle({ className = '' }) {
  const { lang, setLang } = useLang();
  return (
    <div className={`inline-flex rounded-md bg-slate-100 p-0.5 ${className}`}>
      {['nl', 'fr'].map((l) => (
        <button key={l} onClick={() => setLang(l)}
          className={`px-2.5 py-1.5 sm:py-1 rounded text-[11px] font-semibold uppercase tracking-wide transition-colors ${
            lang === l ? 'bg-white text-[#114817] shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}>
          {l}
        </button>
      ))}
    </div>
  );
}
